import { useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';

import { useIsDependant } from 'shared-hooks/task';
import { capitalize } from 'utils/helpers';

import MilestoneName from 'components/milestone-name';
import TaskName from 'components/task-name';
import HelpTooltip from 'components/help-tooltip';

const TaskDependantOn = ({ id, onMilestoneClick, onTaskClick, onIsDependantChange }) => {
    const { t } = useTranslation(['task', 'common']);
    const [isDependant, dependantOn] = useIsDependant(id);

    const handleMilestoneDepClick = () => {
        onMilestoneClick(dependantOn?.id);
    }

    const handleTaskDepClick = () => {
        onTaskClick(dependantOn?.id);
    }

    useEffect(() => {
        onIsDependantChange(isDependant);
    }, [isDependant]);

    if (!isDependant) {
        return null;
    }

    return (
        <div className="content-panel-additional-info">
            <Trans
                i18nKey="task:dependant.text"
                values={{
                    type: t(`common:${capitalize(dependantOn.type)}`).toLowerCase()
                }}
                components={{
                    nameWrap: <strong className="clickable" onClick={dependantOn.type === 'milestone' ? handleMilestoneDepClick : handleTaskDepClick} />,
                    name: dependantOn.type === 'milestone' ? <MilestoneName id={dependantOn.id} /> : <TaskName id={dependantOn.id} />
                }}
            />

            <HelpTooltip theme="semi-light">
                { t(`dependant.help.${dependantOn.type}`) }
            </HelpTooltip>
        </div>
    );
}

export default TaskDependantOn;
